import { NavLink } from "react-router-dom";
import { Flex, useMediaQuery } from "@chakra-ui/react";
import { useSelector, useDispatch } from "react-redux";
import { authClearUser } from "../../../store/actions/authAction";
import { PRIMARY_HEX } from "../../../theme/primary";
import { PROTECTED_PATHS } from "../../../app/constants";
import { successNotifier } from "../../NotificationHandler";
export const LinkTo = ({
  type,
  to,
  classname,
  iconComponent: I,
  btn,
  title,
  toggle,
}) => {
  const [isMobileScreen] = useMediaQuery("(max-width: 600px)");
  const dispatch = useDispatch();
  const unit = useSelector(
    (state) => state?.switchTab?.currentDisplay?.dashboard?.rate?.unit,
  );
  // const getBrandColor = useSelector(state => state.auth?.brandColor)

  const handleLogout = () => {
    // remove the primary auth token and active account, update redux and navigate to login
    try {
      localStorage.removeItem("WMS#221#");
      localStorage.removeItem("ACTIVE_ACCOUNT");
      localStorage.removeItem("WMS_USER");
    } catch (e) {}
    dispatch(authClearUser());
    window.location.replace(`/${type}/login`);
  };

  return btn ? (
    <Flex
      _hover={{
        cursor: "pointer",
        background: "#f2f2f2",
        borderTopLeftRadius: 40,
        fontWeight: "700",
        color: "black",
        borderBottomLeftRadius: 40,
        flex: " 1 0 auto",
      }}
      fontWeight="700"
      onClick={handleLogout}
      className={`${classname} link`}
    >
      {/* <img src={iconComponent} alt="icon" /> */}
      <I />
      {title}
    </Flex>
  ) : (
    <NavLink
      // activeStyle={{
      //   fontWeight: "bold",
      //   color: getBrandColor || "#fff",
      //   background: pageColor,
      //   color: "#fff",
      //   padding: "10px",
      //   // borderLeft: `5px solid #2a9d8f`,
      //   borderRadius: "5px",
      // }}
      style={({ isActive }) => ({
        color: isActive ? "#fff" : "",
        fontWeight: isActive ? "bold" : "normal",
        background: isActive ? PRIMARY_HEX : "",
        padding: isActive ? "10px" : "",
        borderRadius: isActive ? "5px" : "",
      })}
      className={`${classname} link`}
      onClick={(e) => {
        // mobile toggle
        if (isMobileScreen) toggle && toggle();

        // Prevent routing to Buy Water when current commodity is not water
        if (to === PROTECTED_PATHS.BUY_WATER && unit !== "/Liter") {
          e.preventDefault();
          successNotifier(
            "Feature coming soon: this commodity will be available soon",
          );
          return;
        }
        return null;
      }}
      // target={title === "Guest CheckIn" ? "_blank" : ""}
      to={to ? to : "/"}
    >
      {/* <Img src={iconComponent} alt="icon" /> */}
      <I />
      {title}
    </NavLink>
  );
};
